var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpOnlyLogo = function SvgPpOnlyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.487 6.895c3.84 0 4.085-2.53 4.085-3.453S10.328 0 6.487 0H4.405v12.641h-.881V0L.354.905l.164.551 1.39-.396v11.58H0v.575h6.901v-.575H4.992V6.894zm-.32-6.32c2.202 0 2.496 1.997 2.496 2.868s-.294 2.878-2.497 2.878H4.992V.574z"
  })));
};
export default SvgPpOnlyLogo;